import {
  AssemblyGoverningValueDocument,
  GetAssemblyPointOfInterestsDocument,
  GetOneAssemblyForBlistersDocument,
  GetRecommendationsForAssemblyDocument,
  SelectedPointOfInterestDocument,
  usePointOfInterestActivitySubscription,
} from '@/__generated__/graphql';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useApolloClient } from '@apollo/client';
import { RefetchCompleteCallback } from '@/types';

export const useLiveSyncAllPois = (onRefetchComplete?: RefetchCompleteCallback) => {
  const structureId = useGetStructureId();
  const client = useApolloClient();

  usePointOfInterestActivitySubscription({
    variables: {
      structureId: structureId,
    },
    onData: ({ data: pointOfInterestActivity }) => {
      if (pointOfInterestActivity?.data?.pointOfInterestActivity) {
        client
          .refetchQueries({
            include: [
              SelectedPointOfInterestDocument,
              AssemblyGoverningValueDocument,
              GetRecommendationsForAssemblyDocument,
              GetOneAssemblyForBlistersDocument,
              GetAssemblyPointOfInterestsDocument,
            ],
          })
          .then(() => {
            if (onRefetchComplete) {
              onRefetchComplete();
            }
          });
      }
    },
    skip: !structureId,
  });
};

export default useLiveSyncAllPois;
